import React, { useEffect, useState } from "react";
import { api, apiErrorMessage } from "@/api/client";
import { Panel, ActionButton } from "./_shared";
import { Input } from "@/components/ui/input";
import { Save, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

export default function TranslationsManager() {
  const [items, setItems] = useState([]);
  const [draft, setDraft] = useState({ key: "", it: "", en: "", de: "" });

  const load = async () => {
    const { data } = await api.get("/admin/translations");
    setItems(data || []);
  };
  useEffect(() => { load(); }, []);

  const upsert = async (entry) => {
    try {
      await api.put("/admin/translations", entry);
      toast.success("Salvato");
      setDraft({ key: "", it: "", en: "", de: "" });
      load();
    } catch (e) { toast.error(apiErrorMessage(e)); }
  };
  const remove = async (key) => {
    await api.delete(`/admin/translations/${encodeURIComponent(key)}`);
    load();
  };
  const updateField = (idx, field, v) => {
    const copy = [...items];
    copy[idx] = { ...copy[idx], [field]: v };
    setItems(copy);
  };

  return (
    <div className="flex flex-col gap-4">
      <div>
        <h1 className="font-editorial italic text-4xl text-ink-900">Traduzioni</h1>
        <p className="text-xs text-ink-500 mt-1">Sovrascrivi le stringhe dell'interfaccia (chiave = codice usato nell'app, es. <code>home.welcome_heading</code>)</p>
      </div>

      <Panel title="Nuova voce">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-2 items-end">
          <Input placeholder="chiave.dotted" value={draft.key} onChange={(e) => setDraft({ ...draft, key: e.target.value })} className="bg-white"/>
          <Input placeholder="IT" value={draft.it} onChange={(e) => setDraft({ ...draft, it: e.target.value })} className="bg-white"/>
          <Input placeholder="EN" value={draft.en} onChange={(e) => setDraft({ ...draft, en: e.target.value })} className="bg-white"/>
          <Input placeholder="DE" value={draft.de} onChange={(e) => setDraft({ ...draft, de: e.target.value })} className="bg-white"/>
          <ActionButton onClick={() => upsert(draft)} disabled={!draft.key}><Plus className="w-3.5 h-3.5" /> Aggiungi</ActionButton>
        </div>
      </Panel>

      <Panel title="Elenco">
        <div className="flex flex-col divide-y divide-ink-200/30">
          {items.length === 0 && <p className="text-sm text-ink-300 py-6 text-center">Nessuna override ancora. L'app usa le stringhe di default JSON.</p>}
          {items.map((t, idx) => (
            <div key={t.key} className="grid grid-cols-1 md:grid-cols-6 gap-2 py-2 items-center">
              <div className="font-mono text-xs text-ink-700 truncate">{t.key}</div>
              {["it", "en", "de"].map((lng) => (
                <Input key={lng} value={t[lng] || ""} onChange={(e) => updateField(idx, lng, e.target.value)} className="bg-white h-9 text-sm" />
              ))}
              <div className="flex gap-1 md:col-span-2">
                <ActionButton onClick={() => upsert(t)}><Save className="w-3.5 h-3.5" /></ActionButton>
                <ActionButton variant="danger" onClick={() => remove(t.key)}><Trash2 className="w-3.5 h-3.5" /></ActionButton>
              </div>
            </div>
          ))}
        </div>
      </Panel>
    </div>
  );
}
